module.exports = __webpack_public_path__ + "2f68882b5c1a974fa6ca4b2c162d69fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/personal-duration.png
// module id = 1870
// module chunks = 1